import React from 'react'
import { useSelector } from 'react-redux'

const FlipCoinFairnessModalResult = (roundHashDetails) => {
  const { lastBetCoinCount } = useSelector((state) => state.flipCoinGame)

  const coinCount = Number(lastBetCoinCount) || 1
  const raw = String(roundHashDetails?.result ?? '')

  const flipCoinResult = raw
    ? raw.slice(-coinCount).split('')
    : Array(coinCount).fill('0')

  return (
    <div className='col-lg-auto flip-coin-pick-side ps-lg-4 text-center text-lg-end order-0 order-lg-1'>
      <div className='text-center text-lg-start d-inline-block mb-3 mb-lg-0 w-100'>
        <div className='d-flex justify-content-center'>
          <div
            className='btn-group mb-md-3 me-3 me-md-0'
            role='group'
            aria-label='Basic radio toggle button group'
          >
            <input
              type='radio'
              className='btn-check'
              name='coin'
              id='coinfront'
              defaultChecked
            />
            <label className='btn-check-label flip-coin-fairness-modal-result' htmlFor='coinfront' >
              {flipCoinResult.map((element, index) => (
                <img
                  key={index}
                  src={
                    element === '0'
                      ? '/assets/images/flip-coin-game/tails.png'
                      : '/assets/images/flip-coin-game/heads.png'
                  }
                  alt='coin'
                />
              ))}
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FlipCoinFairnessModalResult
